var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Modal',{staticClass:"gong-animation-modal",attrs:{"name":"gong-animation-modal","custom":""}},[_c('GongAnimation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }